'use client'

import NiceModal from '@ebay/nice-modal-react'
import { ThemeProvider } from 'next-themes'
import * as React from 'react'
// import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
export function Providers({ children }: React.PropsWithChildren): React.JSX.Element {
  const queryClient = new QueryClient()

  return (
    // <NuqsAdapter>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute='class' defaultTheme='system' enableSystem disableTransitionOnChange>
        <TooltipProvider>
          <NiceModal.Provider>{children}</NiceModal.Provider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
    // </NuqsAdapter>
  )
}
